
export default {
    name: 'BusinessQuotes',
    props: {
        /**
         * The business object
         */
        business: {
            type: Object,
            required: true,
        },
        /**
         * A User object
         */
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            bookings: [],
            quotes: [],
        };
    },
    async fetch() {
        const [bookings, quotes] = await Promise.all([
            this.$axios.$get(this.$config.endpoints.booking, {
                params: { per_page: 12, organisation_id: this.business.id, completed: 0 },
            }),
            this.$axios.$get(this.$config.endpoints.bid, {
                params: { per_page: 25, organisation_id: this.business.id, accepted: 0 },
            }),
        ]);

        this.bookings = bookings?.bookings?.data || [];
        this.quotes = quotes?.bids?.data || [];
    },
};

